import React from "react";

export const LineDivider = () => {
  return <div className="LineDivider"></div>;
};
